module.exports = __webpack_public_path__ + "static/media/40ch.76d71980.pdf";